module.exports = __webpack_public_path__ + "static/media/derevo_planeta_zvezdy_galaktika_art_117068_1280x1024.fca6f398.jpg";